import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// ─── Main Footer Component ──────────────────────────────────
const Footer = () => {
  // ─── Fake viewers state ──────────────────────────────────
  const [fakeViewers, setFakeViewers] = useState(550);

  useEffect(() => {
    // Update fake viewers every 3–5 seconds
    const interval = setInterval(() => {
      const newCount = Math.floor(Math.random() * 500) + 500; // 500–600
      setFakeViewers(newCount);
    }, 3000 + Math.random() * 2000); // random interval 3–5s

    return () => clearInterval(interval);
  }, []);

  // ─── Existing newsletter handler ────────────────────────
  const handleSubscribe = (e) => {
    e.preventDefault();
    alert('Newsletter subscription feature coming soon!');
  };

  return (
    <footer className="footer-2__area black-bg-2 footer-4">
      <div className="container custom-container">
        <div className="row section-space mb-minus-40">
          {/* Column 1: Logo, Social & Online Viewers */}
          <div className="col-xl-3 col-lg-4 col-md-6">
            <div className="footer-2__widget mb-40">
              <div className="footer-2__logo">
                <Link to="/">
                  <img src="assets/img/logo/logo2025_2_footer.png" alt="logo" />
                </Link>
              </div>
              <p className="footer-2__dec" align="justify">
                Founded in 2007 by veteran journalist <br />Nagabhushan, Bangalore Metro News & TV has emerged as a unique and respected platform dedicated to the police fraternity. Guided by the motto “For the people, By the people, and Of the people,” the magazine has spent nearly two decades highlighting the achievements, challenges, and contributions of public personnel across Karnataka.
              </p>
              <div className="footer-2__social">
                <ul>
                  <li>
                    <a href="https://www.facebook.com/bangaloremetronews" target="_blank" rel="noopener noreferrer">
                      <i className="fa-brands fa-facebook-f" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/bangaloremetronews" target="_blank" rel="noopener noreferrer">
                      <i className="fa-brands fa-instagram" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/BangaloreMetroNews-tv" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-youtube" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Column 2: News Links */}
          <div className="col-xl-2 col-lg-3 col-md-6">
            <div className="footer-2__widget widget-col-2 mb-40">
              <div className="footer-2__menu-wrap">
                <h3 className="footer-2__title">News Links</h3>
                <ul className="footer-2__menu">
                  <li>
                    <Link to="/about">
                      <i className="fa-regular fa-angle-right" /> About Us
                    </Link>
                  </li>
                  <li>
                    <Link to="/interviews">
                      <i className="fa-regular fa-angle-right" /> Interviews
                    </Link>
                  </li>
                  <li>
                    <Link to="/metrobmrcl">
                      <i className="fa-regular fa-angle-right" /> BMRCL
                    </Link>
                  </li>
                  <li>
                    <Link to="/metrobbmp">
                      <i className="fa-regular fa-angle-right" /> BBMP
                    </Link>
                  </li>
                  <li>
                    <Link to="/metrobda">
                      <i className="fa-regular fa-angle-right" /> BDA
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <i className="fa-regular fa-angle-right" /> Public Issues
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Column 3: Corporate Office */}
          <div className="col-xl-4 col-lg-5 col-md-6">
            <div className="footer-2__widget widget-col-3 mb-40">
              <h3 className="footer-2__title">Location:</h3>
              <div className="footer-2__post">
                <div className="footer-2__post-info">
                  <div className="footer-2__post-meta">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d31107.598345544484!2d77.5501734!3d12.9430448!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15f300c74f31%3A0xe4306e239ecbdec4!2sKarnataka%20Police%20TV!5e0!3m2!1sen!2sin!4v1782051751651!5m2!1sen!2sin"
                      width="300"
                      height="300"
                      style={{ border: 0 }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Column 4: Newsletter Subscription */}
          <div className="col-xl-3 col-lg-4 col-md-6">
            <div className="footer-4__widget">
              <h3 className="footer-2__title">Subscribe Newsletter</h3>
              <div className="footer-4__subscribe">
                <form onSubmit={handleSubscribe}>
                  <div className="footer-4__subscribe-input">
                    <input type="email" placeholder="Enter your email" required />
                  </div>
                  <div className="footer-4__subscribe-btn">
                    <button type="submit" className="rr-btn rr-btn-6">
                      <span className="btn-wrap">
                        <span className="text-one">Subscribe Now</span>
                        <span className="text-two">Subscribe Now</span>
                      </span>
                    </button>
                  </div>
                </form>
                <p className="footer-4__subscribe-dec">
                  By pressing the subscribe button, you confirm that you have are agreeing to our{' '}
                  <Link to="/privacy-policy">Privacy Policy</Link> and{' '}
                  <Link to="/terms">Terms of Use.</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Bar */}
      <div className="footer-4__contact">
        <div className="container custom-container">
          <div className="footer-4__contact-wrap mb-minus-20">
            <div className="footer-4__contact-item mb-20">
              <div className="icon"><i className="fa-solid fa-phone" /></div>
              <div className="footer-4__contact-info">
                <span>Phone Number</span>
                <ul>
                  <li><a href="tel:08026623007">080-26623007</a></li>
                  <li><a href="tel:9886977701">+91 98869 77701</a></li>
                  <li><a href="tel:9535150008">+91 95351 50008</a></li>
                </ul>
              </div>
            </div>
            <div className="footer-4__contact-item mb-20">
              <div className="icon"><i className="fa-solid fa-envelope" /></div>
              <div className="footer-4__contact-info">
                <span>Email Address</span>
                <ul>
                  <li><a href="mailto:info@bangaloremetronews.in">info@bangaloremetronews.in</a></li>
                </ul>
              </div>
            </div>
            <div className="footer-4__contact-item mb-20">
              <div className="icon"><i className="fa-solid fa-location-dot" /></div>
              <div className="footer-4__contact-info">
                <span>Corporate Office</span>
                <ul>
                  <li>
                    <a href="https://maps.app.goo.gl/iFnyFrgqSGqgznUPA" target="_blank" rel="noopener noreferrer">
                      #65, 3rd Floor, SSR Archade, Gandhi Bazaar Main Road, Basavanagudi, Bangalore, <br />Karnataka - 560004
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* ─── Fake Viewers Online Counter ─── */}
            <div className="footer-4__contact-item mb-20">
              <div className="footer-4__contact-info">
                <div style={{ marginTop: '1.5rem', borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: '1.2rem' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#a7f3d0' }}>
                    <span style={{ fontSize: '1.2rem' }}>👁️</span>
                    <span style={{ fontWeight: 600, fontSize: '1.1rem' }}>{fakeViewers}</span>
                    <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.9rem' }}>
                      {fakeViewers === 1 ? 'viewer' : 'viewers'} online
                    </span>
                    <span
                      style={{
                        display: 'inline-block',
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        background: '#34d399',
                        marginLeft: '0.2rem',
                        animation: 'blink-dot 1.6s ease-in-out infinite',
                        boxShadow: '0 0 12px rgba(52,211,153,0.3)',
                      }}
                    />
                  </div>
                  <style>{`
                    @keyframes blink-dot {
                      0%, 100% { opacity: 1; transform: scale(1); }
                      50% { opacity: 0.25; transform: scale(0.75); }
                    }
                  `}</style>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="container custom-container">
        <div className="copyright__area">
          <div className="copyright__wrap copyright-4__wrap">
            <div className="copyright__info">
              <p>
                <Link to="/">Bangalore Metro News & TV</Link> ©&nbsp;2007. All rights reserved.
              </p>
            </div>
            <div className="copyright__menu">
              <ul>
                <li><Link to="/terms">Terms &amp; Conditions</Link></li>
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;